import React from 'react';

const PremiumProteinUpgradeModal = ({ confirmData, onConfirm, onCancel }) => (
    <div
        style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000 // Higher than meal modal
        }}
        onClick={onCancel}
    >
        <div
            style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                padding: '30px',
                maxWidth: '400px',
                margin: '20px',
                textAlign: 'center',
                boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <h3 style={{
                margin: '0 0 15px 0',
                color: '#333',
                fontSize: '18px'
            }}>
                Premium Protein Upgrade
            </h3>

            <p style={{
                margin: '0 0 15px 0',
                color: '#666',
                lineHeight: '1.5'
            }}>
                Switching to <strong>{confirmData.proteinName}</strong> will cost an additional <strong>${confirmData.price}</strong>.
            </p>

            <p style={{
                fontSize: '16px',
                color: '#666'
            }}>
                Is that okay?
            </p>

            <div style={{
                display: 'flex',
                gap: '15px',
                justifyContent: 'center'
            }}>
                <button
                    onClick={onCancel}
                    style={{
                        padding: '10px 20px',
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        backgroundColor: '#f8f9fa',
                        color: '#666',
                        cursor: 'pointer',
                        fontSize: '14px'
                    }}
                >
                    Cancel
                </button>
                <button
                    onClick={onConfirm}
                    style={{
                        padding: '10px 20px',
                        border: 'none',
                        borderRadius: '6px',
                        backgroundColor: '#ff7c44',
                        color: 'white',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: 'bold'
                    }}
                >
                    Confirm (+${confirmData.price})
                </button>
            </div>
        </div>
    </div>
);

export default PremiumProteinUpgradeModal;